export const CARD_WIDTH = 378;
export const CARD_HEIGHT = 168;
